'use client';

var translations = {
    'Cập nhật': 'Update',
    'Cập nhật ngay thông tin hồ sơ để Nhà tuyển dụng có thể dễ dàng tìm tiếm và chủ động liên hệ với bạn.': 'Update your profile so that Employers can easily find and actively contact you.',
    'Hồ sơ đính kèm của bạn': 'Your Attached CV',
    'Tải Hồ Sơ': 'Attached CV',
    'Hoàn Chỉnh Hồ Sơ': 'Working Preference',
    'Thông tin liên hệ': 'Contact information',
    'Nhập chức danh': 'Enter job title',
    'Chọn hồ sơ': 'Choose upload file',
    'Tải lên thành công': 'Upload successful',
    'Tải lên thất bại': 'Upload failed',
    'Vui lòng chọn tập tin đính kèm với định dạng .doc, .docx, .pdf nhỏ hơn 5120KB.': 'You can attach .doc, .docx, and .pdf files that are less than 5120KB in size.',
    'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB': '.doc, .docx and .pdf files that are less than 5120KB in size',
    'Đây là thông tin bắt buộc': 'This is a required field',
    'Không có kết quả': 'No result',
    'Cập nhật hồ sơ': 'Update',
    'Không thể cập nhật hồ sơ của bạn': "Can't update your resume",
    'Lỗi ': 'Error',
    'Không thể cập nhật thông tin!': "Can't update your information!",
    'Thành công': 'Successful',
    'Bỏ qua bước này': 'Skip this step',
    'Chọn hồ sơ từ máy bạn': 'Choose file to upload',
    'Hoặc bạn có thể': 'Or you can',
    'Kéo hồ sơ của bạn vào đây': 'Drag your CV here',
    'Hồ sơ của bạn đã được tải lên thành công!': 'Your CV has been uploaded successfully!',
    'Chức danh hiện tại': 'Your Job Title',
    Năm: 'Years',
    'Thông tin bắt buộc': 'This field is required',
    'Vui lòng nhập trường này': 'This field is required',
    'Nơi làm việc mong muốn': 'Places You Want To Work',
    'Ngành nghề mong muốn': 'Job Function You Want To Get Jobs',
    'Bạn chỉ có thể chọn tối đa 3 địa điểm': 'You can only choose maximum 3 locations',
    'Chọn địa điểm': 'Select location',
    'Chọn ngành nghề': 'Select job category',
    'Thông tin được tự động điền cho bạn nếu có thể.': 'Information is parsed and filled in for you automatically if possible.',
    'Trình độ học vấn': 'Highest Education',
    'Mức lương mong muốn tối thiểu': 'Expected Minimum Salary',
    'Mức lương mong muốn': 'Expected Salary',
    'USD/tháng': 'USD/month',
    'Cấp bậc hiện tại': 'Your Current Job Level',
    'Vui lòng chọn ...': 'Please select ...',
    'Hồ sơ đính kèm': 'Attached CV',
    'Lưu hồ sơ': 'Save Profile',
    'Đổi tập tin': 'Change file',
    'Hủy tải tập tin': 'Cancel upload',
    'Tiếp tục': 'Next',
    'Số năm kinh nghiệm': 'Years of Experience',
    'Phiên Sử Dụng Hết Hạn': 'Session Expired',
    'Bạn vui lòng đăng nhập lại': 'Please log in again',
    'Cập nhật thông tin hồ sơ đính kèm': 'Update attachment information',
    'Cho phép tìm kiếm hồ sơ đính kèm': 'Make your attachCV searchable',
    'Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email: ': 'Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email: ',
    'Lĩnh vực mong muốn': 'Industries You Want To Get Jobs',
    'Thông Tin Liên Hệ của bạn đã được cập nhật thành công!': 'Your Contact Information has been updated successfully!',
    Email: 'Email',
    'Ngày sinh': 'Date of Birth',
    'Ví dụ: 23/09/1990': 'e.g. 23/09/1990',
    'Giới tính': 'Gender',
    'Quốc gia': 'Country',
    'Chọn quốc gia': 'Select a country',
    'Quận/Huyện': 'District',
    'Địa chỉ': 'Address',
    'Điện thoại': 'Cell Number',
    'Quốc tịch': 'Nationality',
    'Tình trạng hôn nhân': 'Marital Status',
    'Tỉnh/Thành phố': 'Province/City',
    Nam: 'Male',
    Nữ: 'Female',
    'Độc thân': 'Single',
    'Đã kết hôn': 'Married',
    'Người Việt Nam': 'Local Vietnamese',
    'Người nước ngoài': 'Foreigner',
    'Chọn quốc tịch': 'Select nationality',
    'Vui lòng chọn...': 'Please select...',
    'Không Có Kết Quả Nào': 'No Result Found',
    Tìm: 'Search',
    'Bạn chưa có sẵn hồ sơ đính kèm?': "You don't have a ready attachment?",
    'Cập nhật Hồ sơ VietnamWorks': 'Update VietnamWorks Profile',
    '/ho-so': '/my-profile',
    'Vui lòng nhập thông tin.': 'This field is required.',
    'Vui lòng không nhập số hoặc kí tự đặc biệt.': 'Please do not enter numbers or special characters.',
    'Vui lòng không nhập số điện thoại hoặc email': 'Please do not enter phone number or email.',
    'Vui lòng không nhập kí tự đặc biệt.': 'Please do not enter special characters.',
    'Số điện thoại không hợp lệ': 'This is not a valid phone number',
    'Số điện thoại của bạn không hợp lệ.': 'The phone number format is invalid.'
};
var educationListVi = [
    { id: 0, name: 'Vui lòng chọn học vấn' },
    { id: 2, name: 'Trung học' },
    { id: 3, name: 'Trung cấp' },
    { id: 12, name: 'Cao đẳng' },
    { id: 4, name: 'Cử nhân' },
    { id: 5, name: 'Thạc sĩ' },
    { id: 6, name: 'Tiến sĩ' },
    { id: 11, name: 'Khác' }
];
var educationListEn = [
    { id: 0, name: 'Please select education' },
    { id: 2, name: 'High school' },
    { id: 3, name: "Associate's degree" },
    { id: 12, name: 'College' },
    { id: 4, name: 'Bachelors' },
    { id: 5, name: 'Masters' },
    { id: 6, name: 'Doctorate' },
    { id: 11, name: 'Others' }
];

export { translations as default, educationListEn, educationListVi };
//# sourceMappingURL=translations.js.map
